// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__0zObV","loader":"styles_loader__ampWs"};